'use client';

import { createContext, useContext, useState } from 'react';

import Script from 'next/script';

type YandexPayContextType = {
  loaded: boolean;
};

const YandexPayContext = createContext<YandexPayContextType>({
  loaded: false
});

export const YandexPayProvider = ({ children }: { children: React.ReactNode }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <YandexPayContext.Provider value={{ loaded }}>
      <Script
        id="yandex-pay-sdk"
        src="https://pay.yandex.ru/sdk/v1/pay.js"
        strategy="afterInteractive"
        onLoad={() => setLoaded(true)}
      />
      {children}
    </YandexPayContext.Provider>
  );
};

export const useYandexPayLoaded = () => {
  return useContext(YandexPayContext).loaded;
};
